<template>
  <div>
    <div
      v-if="descriptionBlocks.length"
      class="promo-list-large-desc"
    >
      <div
        v-for="(block, i) in descriptionBlocks"
        :key="`desc-block-${i}`"
        class="promo-list-large-desc__block"
      >
        <h3
          v-if="block.header.length"
          class="promo-list-large-desc__header"
        >
          {{ block.header }}
        </h3>

        <div v-if="block.body.length">
          <p
            v-for="(text, t) in block.body"
            :key="`text-${i+t}`"
            class="promo-list-large-desc__body"
          >
            {{ text }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import type { Location } from '~/core/ts/entity/Location'
import { Promotion } from '~/core/ts/entity/Promotion'
import PromotionLargeDescriptionRepository from '~/core/ts/repository/PromotionLargeDescriptionRepository'

export default defineNuxtComponent({
  props: {
    promotion: {
      type: Object as PropType<Promotion>,
      default: () => null,
    },
    location: {
      type: Object as PropType<Location | null>,
        default: () => null
    },
  },
  setup(props) {
    const getDescriptionBlocks = () => {
      const blocks = PromotionLargeDescriptionRepository.getBySlug(props.promotion.slug)
      if (!blocks) {
        return []
      }

      return blocks
    }

    const descriptionBlocks = getDescriptionBlocks()

    return {
      descriptionBlocks,
    }
  },
})
</script>

<style lang="scss" scoped>
.promo-list-large-desc {
  @apply px-2;
  @apply mb-8;

  &__block {
    @apply block;
    @apply mb-4;
  }

  &__header {
    @apply font-bold;
    @apply text-spl-primary-dark;
    @apply mt-4;
    @apply mb-2;

    @apply text-lg;
  }

  &__body {
    @apply my-1;
    @apply pb-2;
  }
}
</style>
